import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import ListSubheader from '@mui/material/ListSubheader';
import { FormattedMessage } from 'react-intl';

import messages from '../messagesManageAccounts';
import inlineStyles from './accountGroupStyles';

const RavelinDetails = (props) => {
	const { values, handleRavelinApiKeyChange, errors } = props;

	return (
		<div>
			<ListSubheader style={inlineStyles.subHeader}>
				<FormattedMessage {...messages.lbRavelinDetails} />
			</ListSubheader>

			<TextField
				id="ravelinApiKey"
				label={<FormattedMessage {...messages.lbRavelinApiKey} />}
				fullWidth
				value={values.ravelinApiKey}
				onChange={handleRavelinApiKeyChange}
				error={!!errors.srtRavelinApiKey}
				helperText={errors.srtRavelinApiKey}
				variant="standard"
			/>
		</div>
	);
};

RavelinDetails.propTypes = {
	values: PropTypes.object,
	handleRavelinApiKeyChange: PropTypes.func.isRequired,
	errors: PropTypes.object,
};

export default RavelinDetails;
